import { rangeWithDefaultsWhenEmpty } from '../engine/default-handlers';
import { defineFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

const DEFAULT_MIN_OUTFLOW = 0;
const DEFAULT_MAX_OUTFLOW = 100;

export const outflowDescriptor = defineFilter({
  definition: {
    id: FilterId.OUTFLOW,
    name: 'Outflow',
    type: FilterType.RANGE,
    min: DEFAULT_MIN_OUTFLOW,
    max: DEFAULT_MAX_OUTFLOW,
    isActive: false,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_OUTFLOW, segmented: true },
  handler: rangeWithDefaultsWhenEmpty(DEFAULT_MIN_OUTFLOW, DEFAULT_MAX_OUTFLOW),
});
